import React, { useState, useEffect } from "react";
import { Input, Label, FlexBox, FlexBoxDirection, Button } from "@ui5/webcomponents-react";
import localforage from 'localforage';

const SocioeconomicForm7 = ({ formData, onFormChange, handlePrevious, handleNext }) => {
  const [boatEntries, setBoatEntries] = useState(formData.boatEntries || [{}]);
  const [nipaEntries, setNipaEntries] = useState(
    formData.nipaEntries && formData.nipaEntries.length > 0
      ? formData.nipaEntries.map(entry => ({
          ...entry,
          municipalities: entry.municipalities || [],
          barangays: entry.barangays || []
        }))
      : [{ province: "", municipality: "", barangay: "", municipalities: [], barangays: [] }]
  );
  const [fishingGearEntries, setFishingGearEntries] = useState(formData.fishingGearEntries || {});
  const [provinces, setProvinces] = useState([]);

  const vesselTypeOptions = [
    { value: "1", label: "Non-motorized" },
    { value: "2", label: "Motorized" },
    { value: "3", label: "Others specify:" }
  ];

  const materialUsedOptions = [
    { value: "1", label: "Wood" },
    { value: "2", label: "Fiber Glass" },
    { value: "3", label: "Composite" }
  ];

  const fishingGearCategories = {
    "Hook and Line": [
      "Simple and hand line (Kawil)",
      "Multiple hand line (birabira, pangawil, pangundak, panlagaw, ug-ug)",
      "Bottom set long line (Kitangna pang-ilalim ng dagat)",
      "Drift long line (kitang na paanod sa ibabaw ng dagat)",
      "Troll line (Pahila, Salabay)",
      "Squid jigs (Pamusit, Saranggat)"
    ],
    "Seine Nets": [
      "Beach seine (pukot)",
      "Fry dozer or gatherer (salap)",
      "Cast Net (Dala, bitak)",
      "Man push nets (sudsod, tunod, sagap)",
      "Scoop nets (sirok, sigma)"
    ],
    "Falling Gear": ["Filter nets (Lumpot)"],
    "Lift Nets": [
      "Crab lift nets (Bintol ng Alimango)",
      "Fish lift nets (Basnig/Bagnet)",
      "New Look o Zapra",
      "Shrimp lift nets (Bintol ng Hipon/Sugpo)",
      "Lever nets (Salambaw)"
    ],
    "Pots and Traps": [
      "Fish pots (Bubo ng Isda)",
      "Crab pots (Bubo ng Alimango)",
      "Squid pots (Bubo ng pusit)",
      "Fyke nets (Skylab/Palos)"
    ],
    "Gill Nets": [
      "Surface set gill net",
      "Drift gill net (panting paanod)",
      "Bottom set gill net (panting palubog)",
      "Trammel net (Transmallo, Pangubiw)",
      "Encircling gill net",
      "Shrimp gill net (Galagdag, Pamasayan, Lait)"
    ],
    "Miscellaneous Fishing Gear": [
      "Spear (Pana)",
      "Octopus/squid luring device (Pangati/Pamusit)",
      "Gaff hook (Ganso, Panikwat)"
    ]
  };

  useEffect(() => {
    fetchProvinces();
  }, []);

  useEffect(() => {
    if (provinces.length > 0) {
      nipaEntries.forEach((entry, index) => {
        if (entry.province && (!entry.municipalities || entry.municipalities.length === 0)) {
          fetchMunicipalitiesForNipa(entry.province, index);
        }
      });
    }
  }, [provinces]);

  useEffect(() => {
    onFormChange("boatEntries", boatEntries);
  }, [boatEntries, onFormChange]);

  useEffect(() => {
    const entriesToSave = nipaEntries.map(({ municipalities, barangays, ...rest }) => rest);
    onFormChange("nipaEntries", entriesToSave);
  }, [nipaEntries, onFormChange]);

  useEffect(() => {
    onFormChange("fishingGearEntries", fishingGearEntries);
  }, [fishingGearEntries, onFormChange]);

  const fetchProvinces = async () => {
    const cacheProvinceKey = 'location_province';
    try {
      const data = await localforage.getItem(cacheProvinceKey);
      setProvinces(data.data);
    } catch (error) {
      console.error("Failed to fetch provinces:", error);
    }
  };

  const fetchMunicipalitiesForNipa = async (provinceId, index) => {
    const cacheMunicipalityKey = 'location_municipality';
    if (!provinceId) {
      setNipaEntries((prev) =>
        prev.map((entry, i) =>
          i === index ? { ...entry, municipality: "", barangay: "", municipalities: [], barangays: [] } : entry
        )
      );
      return;
    }
    try {
      const data = await localforage.getItem(cacheMunicipalityKey);
      const filteredData = Array.isArray(data.data)
      ? data.data.find(item => item.province_id === Number(provinceId))?.municipalities
      : [];
      setNipaEntries((prev) =>
        prev.map((entry, i) => {
          if (i === index) {
            const existingMunicipalityStillValid = filteredData.some(mun => mun.municipality_id === entry.municipality);
            const updatedEntry = {
              ...entry,
              municipalities: filteredData,
              municipality: existingMunicipalityStillValid ? entry.municipality : "",
              barangay: existingMunicipalityStillValid ? entry.barangay : "",
              barangays: existingMunicipalityStillValid ? entry.barangays : []
            };
            if (!existingMunicipalityStillValid || (existingMunicipalityStillValid && (!updatedEntry.barangays || updatedEntry.barangays.length === 0))) {
              if (updatedEntry.municipality) {
                fetchBarangaysForNipa(updatedEntry.municipality, index);
              } else {
                updatedEntry.barangays = [];
              }
            }
            return updatedEntry;
          }
          return entry;
        })
      );
    } catch (error) {
      console.error("Failed to fetch municipalities:", error);
      setNipaEntries((prev) =>
        prev.map((entry, i) =>
          i === index ? { ...entry, municipality: "", barangay: "", municipalities: [], barangays: [] } : entry
        )
      );
    }
  };

  const fetchBarangaysForNipa = async (municipalityId, index) => {
    const cacheBarangayKey = 'location_barangay';
    if (!municipalityId) {
      setNipaEntries((prev) =>
        prev.map((entry, i) =>
          i === index ? { ...entry, barangay: "", barangays: [] } : entry
        )
      );
      return;
    }
    try {
      const data = await localforage.getItem(cacheBarangayKey);
      const filteredData = Array.isArray(data.data)
      ? data.data.find(item => item.municipality_id === Number(municipalityId))?.barangays
      : [];
      setNipaEntries((prev) =>
        prev.map((entry, i) => {
          if (i === index) {
            const existingBarangayStillValid = filteredData.some(bgy => bgy.barangay_id === entry.barangay);
            return {
              ...entry,
              barangays: filteredData,
              barangay: existingBarangayStillValid ? entry.barangay : ""
            };
          }
          return entry;
        })
      );
    } catch (error) {
      console.error("Failed to fetch barangays:", error);
      setNipaEntries((prev) =>
        prev.map((entry, i) =>
          i === index ? { ...entry, barangay: "", barangays: [] } : entry
        )
      );
    }
  };

  const handleAddBoatEntry = () => {
    setBoatEntries((prev) => [...prev, {}]);
  };

  const handleDeleteBoatEntry = (index) => {
    setBoatEntries((prev) => prev.filter((_, i) => i !== index));
  };

  const handleBoatInputChange = (index, field, value) => {
    setBoatEntries((prev) =>
      prev.map((entry, i) => (i === index ? { ...entry, [field]: value } : entry))
    );
  };

  const handleBoatQuantityChange = (field, index, delta) => {
    setBoatEntries((prev) =>
      prev.map((entry, i) =>
        i === index
          ? { ...entry, [field]: Math.max(0, (entry[field] || 0) + delta) }
          : entry
      )
    );
  };

  const handleAddNipaEntry = () => {
    setNipaEntries((prev) => [...prev, { province: "", municipality: "", barangay: "", municipalities: [], barangays: [] }]);
  };

  const handleDeleteNipaEntry = (index) => {
    setNipaEntries((prev) => prev.filter((_, i) => i !== index));
  };

  const handleNipaInputChange = (index, field, value) => {
    setNipaEntries((prev) =>
      prev.map((entry, i) => {
        if (i === index) {
          const updatedEntry = { ...entry, [field]: value };
          if (field === "province") {
            updatedEntry.municipality = "";
            updatedEntry.barangay = "";
            updatedEntry.municipalities = [];
            updatedEntry.barangays = [];
            fetchMunicipalitiesForNipa(value, index);
          } else if (field === "municipality") {
            updatedEntry.barangay = "";
            updatedEntry.barangays = [];
            fetchBarangaysForNipa(value, index);
          }
          return updatedEntry;
        }
        return entry;
      })
    );
  };

  const handleFishingGearChange = (category, gear, delta) => {
    setFishingGearEntries((prev) => ({
      ...prev,
      [category]: {
        ...(prev[category] || {}),
        [gear]: Math.max(0, ((prev[category] || {})[gear] || 0) + delta)
      }
    }));
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "1200px", margin: "auto" }}>
      <h2>D7. Boat or Fishery Vessel</h2>
      {boatEntries.map((entry, index) => (
        <FlexBox key={index} direction={FlexBoxDirection.Column} style={{ gap: "0.5rem", marginBottom: "1rem" }}>
          <Label>Entry {index + 1}</Label>
          <Label>Vessel Type</Label>
          <select
            value={entry.vesselType || ""}
            onChange={(e) =>
              handleBoatInputChange(index, "vesselType", e.target.value)
            }
            style={{ width: "100%", padding: "0.5rem", fontSize: "0.9rem" }}
          >
            <option value="">Select Vessel Type</option>
            {vesselTypeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {entry.vesselType === "3" && (
            <Input
              placeholder="Specify Other Vessel Type"
              value={entry.vesselTypeOther || ""}
              onInput={(e) =>
                handleBoatInputChange(index, "vesselTypeOther", e.target.value.toUpperCase())
              }
              style={{ textTransform: "uppercase" }}
            />
          )}
          <Label>Quantity or Bilang</Label>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Button
              design="Transparent"
              onClick={() => handleBoatQuantityChange("vesselQuantity", index, -1)}
              style={{
                fontSize: "0.9rem",
                padding: "0.25rem 0.5rem",
                border: "1px solid #ccc",
                borderRadius: "4px"
              }}
            >
              -
            </Button>
            <span
              style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                padding: "0.25rem 0.5rem",
                border: "1px solid #ccc",
                borderRadius: "4px",
                backgroundColor: "#fff",
                textAlign: "center",
                minWidth: "2rem"
              }}
            >
              {entry.vesselQuantity || 0}
            </span>
            <Button
              design="Transparent"
              onClick={() => handleBoatQuantityChange("vesselQuantity", index, 1)}
              style={{
                fontSize: "0.9rem",
                padding: "0.25rem 0.5rem",
                border: "1px solid #ccc",
                borderRadius: "4px"
              }}
            >
              +
            </Button>
          </div>
          <Label>Material Used</Label>
          <select
            value={entry.materialUsed || ""}
            onChange={(e) =>
              handleBoatInputChange(index, "materialUsed", e.target.value)
            }
            style={{ width: "100%", padding: "0.5rem", fontSize: "0.9rem" }}
          >
            <option value="">Select Material</option>
            {materialUsedOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <Label>Bilang &lt;3 Gross Tonnage (Municipal)</Label>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Button
              design="Transparent"
              onClick={() => handleBoatQuantityChange("municipalCount", index, -1)}
              style={{
                fontSize: "0.9rem",
                padding: "0.25rem 0.5rem",
                border: "1px solid #ccc",
                borderRadius: "4px"
              }}
            >
              -
            </Button>
            <span
              style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                padding: "0.25rem 0.5rem",
                border: "1px solid #ccc",
                borderRadius: "4px",
                backgroundColor: "#fff",
                textAlign: "center",
                minWidth: "2rem"
              }}
            >
              {entry.municipalCount || 0}
            </span>
            <Button
              design="Transparent"
              onClick={() => handleBoatQuantityChange("municipalCount", index, 1)}
              style={{
                fontSize: "0.9rem",
                padding: "0.25rem 0.5rem",
                border: "1px solid #ccc",
                borderRadius: "4px"
              }}
            >
              +
            </Button>
          </div>
          <Label>Bilang &gt;3 Gross Tonnage (Commercial)</Label>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Button
              design="Transparent"
              onClick={() => handleBoatQuantityChange("commercialCount", index, -1)}
              style={{
                fontSize: "0.9rem",
                padding: "0.25rem 0.5rem",
                border: "1px solid #ccc",
                borderRadius: "4px"
              }}
            >
              -
            </Button>
            <span
              style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                padding: "0.25rem 0.5rem",
                border: "1px solid #ccc",
                borderRadius: "4px",
                backgroundColor: "#fff",
                textAlign: "center",
                minWidth: "2rem"
              }}
            >
              {entry.commercialCount || 0}
            </span>
            <Button
              design="Transparent"
              onClick={() => handleBoatQuantityChange("commercialCount", index, 1)}
              style={{
                fontSize: "0.9rem",
                padding: "0.25rem 0.5rem",
                border: "1px solid #ccc",
                borderRadius: "4px"
              }}
            >
              +
            </Button>
          </div>
          <Button onClick={() => handleDeleteBoatEntry(index)}>Delete Entry</Button>
        </FlexBox>
      ))}
      <Button onClick={handleAddBoatEntry}>Add Entry</Button>

      <h2>D8. Nipa Production</h2>
      {nipaEntries.map((entry, index) => (
        <FlexBox key={index} direction={FlexBoxDirection.Column} style={{ gap: "0.5rem", marginBottom: "1rem" }}>
          <Label>Entry {index + 1}</Label>
          <Input
            placeholder="Nipa Product"
            value={entry.product || ""}
            onInput={(e) => handleNipaInputChange(index, "product", e.target.value.toUpperCase())}
            style={{ textTransform: "uppercase" }}
          />
          <Input
            placeholder="Volume/Quantity per Year"
            value={entry.volume || ""}
            onInput={(e) => handleNipaInputChange(index, "volume", e.target.value.toUpperCase())}
            style={{ textTransform: "uppercase" }}
          />
          <Label>Location</Label>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "1rem" }}>
            <select
              value={entry.province || ""}
              onChange={(e) => handleNipaInputChange(index, "province", e.target.value)}
              style={{ width: "100%", padding: "0.5rem" }}
            >
              <option value="">Select Province</option>
              {Array.isArray(provinces) && provinces.length > 0 && provinces.map((prov) => (
                <option key={prov.province_id} value={prov.province_id}>
                  {prov.province_name}
                </option>
              ))}
            </select>
            <select
              value={entry.municipality || ""}
              onChange={(e) => handleNipaInputChange(index, "municipality", e.target.value)}
              style={{ width: "100%", padding: "0.5rem" }}
              disabled={!entry.province || !entry.municipalities || entry.municipalities.length === 0}
            >
              <option value="">Select City/Municipality</option>
              {(entry.municipalities || []).map((mun) => (
                <option key={mun.municipality_id} value={mun.municipality_id}>
                  {mun.municipality_name}
                </option>
              ))}
            </select>
            <select
              value={entry.barangay || ""}
              onChange={(e) => handleNipaInputChange(index, "barangay", e.target.value)}
              style={{ width: "100%", padding: "0.5rem" }}
              disabled={!entry.municipality || !entry.barangays || entry.barangays.length === 0}
            >
              <option value="">Select Barangay</option>
              {(entry.barangays || []).map((bgy) => (
                <option key={bgy.barangay_id} value={bgy.barangay_id}>
                  {bgy.barangay_name}
                </option>
              ))}
            </select>
          </div>
          <Button onClick={() => handleDeleteNipaEntry(index)}>Delete Entry</Button>
        </FlexBox>
      ))}
      <Button onClick={handleAddNipaEntry}>Add Entry</Button>

      <h2>D9. Types of Fishing Gears</h2>
      {Object.entries(fishingGearCategories).map(([category, gears]) => (
        <div key={category} style={{ marginBottom: "2rem" }}>
          <h3>{category}</h3>
          {gears.map((gear) => (
            <div key={gear} style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
              <Label style={{ flex: 1 }}>{gear}</Label>
              <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                <Button
                  design="Transparent"
                  onClick={() => handleFishingGearChange(category, gear, -1)}
                  style={{
                    fontSize: "0.9rem",
                    padding: "0.25rem 0.5rem",
                    border: "1px solid #ccc",
                    borderRadius: "4px"
                  }}
                >
                  -
                </Button>
                <span
                  style={{
                    fontSize: "0.9rem",
                    fontWeight: "bold",
                    padding: "0.25rem 0.5rem",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                    textAlign: "center",
                    minWidth: "2rem"
                  }}
                >
                  {(fishingGearEntries[category] || {})[gear] || 0}
                </span>
                <Button
                  design="Transparent"
                  onClick={() => handleFishingGearChange(category, gear, 1)}
                  style={{
                    fontSize: "0.9rem",
                    padding: "0.25rem 0.5rem",
                    border: "1px solid #ccc",
                    borderRadius: "4px"
                  }}
                >
                  +
                </Button>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default SocioeconomicForm7;
